import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a581198"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-task-template-form",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "templateWrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create Task Template", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("p", null, " A Task template represents a repeatable task. When creating a new task from the template, the new task retains a reference to its template. Task templates are used within job templates to define the tasks needed for the job. "),
  /*#__PURE__*/_createElementVNode("p", null, " Task Template provides some predefined attributes( Work Center, Cost Center) to the task so that every time we create a new task we don't have to assign those attributes to the task. These templates will also help us to Group the Tasks according to the template to which they belong to. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateName" }, [
  /*#__PURE__*/_createTextVNode("Template Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateDesc" }, [
  /*#__PURE__*/_createTextVNode("Template Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_12 = { class: "row form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateWorkcenter" }, [
  /*#__PURE__*/_createTextVNode("Work Center"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Select a work center for this task template")
], -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateCostcenter" }, [
  /*#__PURE__*/_createTextVNode("Cost Center"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Select a cost center for this task template")
], -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "jobTemplateName" }, [
  /*#__PURE__*/_createTextVNode("Job Template Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Select a Job Template to which this Task Template will belong to")
], -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "jobTemplateOrder" }, [
  /*#__PURE__*/_createTextVNode("Job Template Order "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Select a Job Template of this Task Template")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary create-tasktemplate-btn",
    type: "submit"
  }, "Save")
], -1))

import { ref, reactive, onMounted } from 'vue';
import { fetchAllJobTemplates, postToUrl } from '@/api/api';
import { useOpsSupplementStore } from '@/stores/OpsSupplement';
import { JobTemplate } from '@/types/Ops';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTaskTemplate',
  setup(__props) {

const opsSupp = useOpsSupplementStore();

const taskTemplate = reactive({
  name: '',
  description: '',
  workCenterId: null,
  costCenterId: null,
  jobTemplateId: null,
  jobTemplateOrder: 0
});

const { work_centers, cost_centers } = storeToRefs(opsSupp);
const jobTemplates = ref<JobTemplate[]>([]);

const resetForm = () => {
  taskTemplate.name = '';
  taskTemplate.description = '';
  taskTemplate.workCenterId = null;
  taskTemplate.costCenterId = null;
  taskTemplate.jobTemplateId = null;
  taskTemplate.jobTemplateOrder = 0;
};

onMounted(async () => {
  await opsSupp.fetch();
  jobTemplates.value = await fetchAllJobTemplates();
});

const saveTaskTemplate = async () => {
  try {
    const payload = {
      name: taskTemplate.name,
      description: taskTemplate.description,
      work_center_id: taskTemplate.workCenterId,
      cost_center_id: taskTemplate.costCenterId,
      job_template: taskTemplate.jobTemplateId,
      job_template_order: taskTemplate.jobTemplateOrder
    };
    // console.log("Sending Payload:", payload); // Log the payload
    const response = await postToUrl('/ops/api/tasktemplates/', payload);
    // console.log("Task Template Created:", response);
    alert("Task Template created successfully!");
    resetForm();
  } catch (error) {
    // console.error("Error creating task template:", error);
    alert("Failed to create Task Template. Please check the data and try again.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("form", {
        onSubmit: _withModifiers(saveTaskTemplate, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            id: "templateName",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((taskTemplate.name) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, taskTemplate.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("textarea", {
            id: "templateDesc",
            cols: "30",
            rows: "5",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((taskTemplate.description) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, taskTemplate.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            id: "templateWorkcenter",
            class: "form-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((taskTemplate.workCenterId) = $event)),
            required: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(work_centers), (workCenter) => {
              return (_openBlock(), _createElementBlock("option", {
                key: workCenter.id,
                value: workCenter.id
              }, _toDisplayString(workCenter.name), 9, _hoisted_14))
            }), 128))
          ], 512), [
            [_vModelSelect, taskTemplate.workCenterId]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("select", {
            id: "templateCostcenter",
            class: "form-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((taskTemplate.costCenterId) = $event)),
            required: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cost_centers), (costCenter) => {
              return (_openBlock(), _createElementBlock("option", {
                key: costCenter.id,
                value: costCenter.id
              }, _toDisplayString(costCenter.name), 9, _hoisted_17))
            }), 128))
          ], 512), [
            [_vModelSelect, taskTemplate.costCenterId]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            id: "jobTemplateName",
            class: "form-select",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taskTemplate.jobTemplateId) = $event)),
            required: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobTemplates.value, (jobTemplate) => {
              return (_openBlock(), _createElementBlock("option", {
                key: jobTemplate.id,
                value: jobTemplate.id
              }, _toDisplayString(jobTemplate.name), 9, _hoisted_20))
            }), 128))
          ], 512), [
            [_vModelSelect, taskTemplate.jobTemplateId]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            id: "jobTemplateOrder",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((taskTemplate.jobTemplateOrder) = $event)),
            type: "number",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              taskTemplate.jobTemplateOrder,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _hoisted_23
      ], 32)
    ])
  ]))
}
}

})